var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "timeSwitch" },
    _vm._l(_vm.mSwitchTags, function(item, index) {
      return _c(
        "div",
        {
          key: index,
          class: { active: index === _vm.currentIndex },
          on: {
            click: function($event) {
              return _vm.btSwitch(item, index)
            }
          }
        },
        [_vm._v(_vm._s(item.name) + "\n  ")]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3c48ebce", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c48ebce","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/szrt_revision/new_account_settings/accountSettings/overallStatistics/components/mSwitch.vue
// module id = null
// module chunks = 